// @ts-nocheck
/* eslint-disable */
export default class Melown3dTexture {
	/**
	 * Vytvoreni texturovaci jednotky pro 3d.
	 *
	 * @param   {String}  textureSrc Odkaz na obrazek - sprite
	 * @param   {Object}  textureMapping Mapovani objektu na obrazek - objekt, klice = jmeno, ktery ma parametry x, y, w, h...
	 * @param   {Number}  [ratio = 1] Pomer pro prepocitani vstupniho obrazku
	 */
	constructor(textureSrc, textureMapping, ratio) {
		this._src = textureSrc;
		this._mapping = textureMapping;
		this._ratio = ratio || 1;
		this._img = null;
		this._dom = {};
		this._dom.canvas = document.createElement("canvas");
		this._ctx = this._dom.canvas.getContext("2d");
		this._cache = {};
		this._loaded = false;
		this._renderResolve = null;
		this._renderProm = new Promise(resolve => { this._renderResolve = resolve; });
		this._loadProm = Promise.all([this._renderProm, this._init()]).then(() => {
			this._loaded = true;
		}, e => {});
	}

	/**
	 * Nastaveni renderu pro textury po nacteni melown prohlizecky.
	 *
	 * @param   {MelownRender}  render
	 */
	set render(render) {
		this._render = render;

		if (this._render) {
			this._renderResolve();
		}
	}

	/**
	 * Ziskani vlastni textury
	 *
	 * @param {String} name Mapovani do textur - bigMarkerActive napr.
	 * @param {Object} [confArg] Konfigurace
	 * @param {String} [confArg.texture = ""] Textura - mapovani do textur
	 * @param {String} [confArg.fontColor] Barva pro vypis pisma
	 * @param {String} [confArg.font] Font pro vypis pisma
	 * @param {String} [confArg.text] Vlastni text k vypisu
	 * @param {String} [confArg.src] Cesta k vlastnimu obrazu na vlozeni
	 * @return {Promise} Objekt s obrazkem, texturou, sirkou, vyskou
	 */
	get(name, confArg) {
		let conf = Object.assign({
			texture: "",
			fontColor: "#000",
			font: "10px Arial",
			text: "",
			src: ""
		}, confArg);
		let key = `${name}_${JSON.stringify(conf)}`;

		if (!(key in this._cache)) {
			// nove vytvoreni
			this._cache[key] = new Promise((resolve, reject) => {
				if (!(name in this._mapping)) {
					reject(new Error("Mapping name does not exist!"));
				}
				else {
					// mam obrazek a da se do textury zapisovat?
					if (conf.src) {
						let img = new Image();
						img.addEventListener("load", e => {
							this._getImageLoad(name, conf, resolve, reject, img);
						});
						img.addEventListener("error", e => {
							reject(e);
						});
						img.crossOrigin = "anonymous";
						img.src = conf.src;
					}
					else {
						this._getImageLoad(name, conf, resolve, reject, null);
					}
				}
			});
		}

		return this._cache[key];
	}

	/**
	 * Nacteni textury.
	 */
	_init() {
		return new Promise((resolve, reject) => {
			this._img = new Image();
			this._img.addEventListener("load", e => {
				let w = Math.round(this._img.width / this._ratio);
				let h = Math.round(this._img.height / this._ratio);

				this._dom.canvas.width = w;
				this._dom.canvas.height = h;
				this._ctx.drawImage(this._img, 0, 0, this._img.width, this._img.height, 0, 0, w, h);

				resolve();
			});
			this._img.addEventListener("error", e => {
				reject(e);
			});
			this._img.src = this._src;
		});
	}

	/**
	 * Mezikrok pro metodu get.
	 * Mame nacteny obrazek/nebo jej nepotrebujeme, v tomto kroku zkontrolujeme, zdali jsme uz nacteni.
	 *
	 * @param {String} name Mapovani do textur - bigMarkerActive napr.
	 * @param {Object} [conf] Konfigurace
	 * @param   {Function}  resolve  Funkce z promise
	 * @param   {Function}  reject   Funkce z promise
	 * @param   {Image}  [img] Volitelne obrazek z conf.src
	 */
	_getImageLoad(name, conf, resolve, reject, img) {
		// je jiz nacteno?
		if (this._loaded) {
			this._getFinish(name, conf, resolve, reject, img);
		}
		else {
			// pockame na promise
			this._loadProm.then(() => {
				this._getFinish(name, conf, resolve, reject, img);
			}, e => {});
		}
	}

	/**
	 * Posledni krok metody get.
	 * Jednotlive dokresleni potrebnych veci a vraceni objektu s daty pres resolve.
	 *
	 * @param {String} name Mapovani do textur - bigMarkerActive napr.
	 * @param {Object} [conf] Konfigurace
	 * @param   {Function}  resolve  Funkce z promise
	 * @param   {Function}  reject   Funkce z promise
	 * @param   {Image}  [img] Volitelne obrazek z conf.src
	 */
	_getFinish(name, conf, resolve, reject, img) {
		let mapItem = this._mapping[name];
		let scaledItem = this._getScaledItem(mapItem);
		let canvas = document.createElement("canvas");
		canvas.width = scaledItem.w;
		canvas.height = scaledItem.h;
		let ctx = canvas.getContext("2d");

		// vydej ciste textury
		ctx.drawImage(this._img, mapItem.x, mapItem.y, mapItem.w, mapItem.h, 0, 0, scaledItem.w, scaledItem.h );

		// kresleni textury
		if (conf.texture) {
			let innerItem = this._mapping[conf.texture];

			if (!innerItem) {
				reject(new Error(`Mapping inner name ${conf.texture} does not exist!`));
			}
			else {
				let scaledInnerItem = this._getScaledItem(innerItem);
				let center = this._centerItem(scaledItem, scaledInnerItem.w, scaledInnerItem.h);
				// vykreslime vnitrni texturu
				ctx.drawImage(this._img, innerItem.x, innerItem.y, innerItem.w, innerItem.h, center.x1, center.y1, center.w1, center.h1);
			}
		}

		// vlastni obrazek
		if (img) {
			let center = this._centerItem(scaledItem, img.width, img.height);
			// vykreslime vnitrni texturu
			ctx.drawImage(img, 0, 0, img.width, img.height, center.x1, center.y1, center.w1, center.h1);
		}

		// text
		if (conf.text) {
			ctx.font = conf.font;
			let size = ctx.measureText(conf.text);
			let m = conf.font.match(/^\d+/);
			// ta mrdka meausureText neumi vracet vysku :(
			let height = m && m.length == 1 ? -parseInt(m[0])/2 : 0;
			let center = this._centerItem(scaledItem, size.width, height);
			ctx.fillStyle = conf.fontColor;
			ctx.fillText(conf.text, center.x1, center.y1);
		}

		// vystupni obrazek
		let image = new Image();
		image.addEventListener("load", () => {
			// vraceni dat
			resolve({
				image,
				width: image.width,
				height: image.height,
				anchorLeft: scaledItem.al || 0,
				anchorTop: scaledItem.at || 0,
				texture: this._render.createTexture({
					source: image
				})
			});
		});
		image.src = canvas.toDataURL();
	}

	/**
	 * Ziskani objektu s prepocitanyma hodnota podle ratio.
	 *
	 * @param   {Object}  item  Vstupni objekt
	 * @return  {Object}  nova kopie objektu s prepocitanymi hodnotami
	 */
	_getScaledItem(item) {
		let output = Object.assign({}, item);

		["w", "h", "iw", "ih", "l", "t", "al", "at"].forEach(key => {
			if (key in output) {
				output[key] = Math.round(output[key] / this._ratio);
			}
		});

		return output;
	}

	/**
	 * Vystred u zadaho objektu vlozeny obrazek o sirce a vysce.
	 *
	 * @param   {Object}  scaledItem  Vstupni objekt, ktery je jiz po skalovani s ratio
	 * @param   {Number}  w Sirka vlozeneho obrazku
	 * @param   {Number}  h Vyska vlozeneho obrazku
	 * @return  {Object} vystupni objekt - x1, y1 - kde obrazek umistit, w1, h1 - jeho nova sirka a vyska
	 */
	_centerItem(scaledItem, w, h) {
		let x1 = scaledItem.l;
		let y1 = scaledItem.t;
		let w1 = Math.min(w, scaledItem.iw);
		let h1 = Math.min(h, scaledItem.ih);
		x1 += Math.round((scaledItem.iw - w1) / 2);
		y1 += Math.round((scaledItem.ih - h1) / 2);

		return {
			x1,
			y1,
			w1,
			h1
		};
	}
}
